import { User } from 'mvppoker-portal-common/api'
import React from 'react'
import { MVPButton } from '../../Buttons/MVPButton'
import { MVPTextInput } from '../../TextInput/MVPTextInput'
import './ReferralModal.scss'

export interface ReferralModalViewProps
{
	user: User
	clickCode: () => void
	clickLink: () => void
}
export const ReferralModalView : React.FC<ReferralModalViewProps> = ({ user, clickCode, clickLink }) =>
{
	return (
		<>
			<span className='modal-title-l'>Referral</span>
			<span className='modal-subtitle'>Invite a friend</span>
			<MVPTextInput value={user.info.referralCode} disabled />
			<div className='buttons'>
				<MVPButton className='light' onClick={clickCode}>
					Share Code
				</MVPButton>
				<MVPButton className='light' onClick={clickLink}>
					Share invitation link
				</MVPButton>
			</div>
		</>
	)
}